<template>
  <div class="picmanger">
    <div class="rightmouse"
         :style="{ top: rightMouseTop + 'px', left: rightMouseLeft + 'px' ,opacity : rightMouseFlag ? '1' : '0'}">
      <p>© 图片版权保护</p>
    </div>
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>邀约与征稿</el-breadcrumb-item>
          <el-breadcrumb-item>查看图片邀约的图片</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="goback"
           class="goback">
        <i class="el-icon-arrow-left"></i>
        <p>返回</p>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main"
         v-loading="isRefresh">
      <div class="head">
        <h4>查看图片邀约的图片</h4>
        <!-- <p>+新增用户</p> -->
        <div class="btn">
          <button @click="downloadPicNeed"
                  :style="{ background:downloadPicText == '正在生成压缩包' ?'#909399':'rgba(255, 141, 5, 1)'}">
            <img src="@/assets/sreenpic/download.png"
                 alt="">
            {{downloadPicText}}
          </button>
          <button @click="picNeedDown"
                  v-if="isCreate">
            <img src="@/assets/sreenpic/download.png"
                 alt="">
            {{'下载压缩包'}}
          </button>
        </div>
      </div>

      <!-- <div class="search">
        征稿活动
        <p style="margin-right:15px;">征稿活动:</p>
        征稿活动
        <el-select v-model="activity" style="width:20%" filterable placeholder="不限">
          <el-option
            v-for="item in activityList"
            :key="item.value + '-3'"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        审核
        <p style="margin: 0 15px;">审核:</p>
        审核
        <el-select v-model="isCheck" filterable placeholder="不限">
          <el-option
            v-for="item in isCheckList"
            :key="item.value + '-2'"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        状态
        <p style="margin: 0 15px;">状态:</p>
        状态
        <el-select v-model="status" filterable placeholder="不限">
          <el-option
            v-for="item in statusList"
            :key="item.value + '-1'"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-button style="margin: 0 15px;" @click="searchClick" class="btn">搜索</el-button>
      </div> -->

      <div class="bigbj">
        <div class="tablebg"
             v-for="(e,i) in listPictureActivity"
             :key="i">
          <div class="head disflex">
            <div class="left disflex">
              <div>{{e.createAtMy}}</div>
              <div style="margin-left:25px;font-size:17px;font-weight:bold;color:rgba(51,51,51,1);">{{e.title}}</div>
              <div style="margin-left:60px;font-size:12px;">创建人：{{e.createName}}</div>
            </div>
            <!-- <div class="right disflex">
              <div @click="seeInf(e)">
                <i class="el-icon-view" style="margin-right:5px;"></i>查看内容
              </div>
              <div @click="checkClicksh(e.id)" v-if="e.isCheck === 0" class="shenhe">
                <i class="el-icon-finished" style="margin-right:5px;"></i>审核
              </div>
              <div @click="checkClickfs(e.id)" v-if="e.isCheck === 1" class="fanshen">
                <i class="el-icon-document-checked" style="margin-right:5px;"></i>反审
              </div>
              <div @click="putIn(e)">
                <i class="el-icon-folder-add" style="margin-right:5px;"></i>入库
              </div>
              <div @click="useGao(e)">
                <i class="el-icon-edit" style="margin-right:5px;"></i>用稿
              </div>
            </div> -->
          </div>

          <div :ref="'tablebgbody' + i"
               class="tablebgbody">
            <div @click="actLeft(i)"
                 v-if="e.pictureCount > 7"
                 class="left">
              <img src="@/assets/picbrowse/leftjt.png"
                   width="20px"
                   alt />
            </div>

            <div :ref="'actimg' + i"
                 class="actimg">
              <div class="imgs"
                   @click="openDialog(ci,ce,e)"
                   v-for="(ce,ci) in e.pictureInfo"
                   :key="ci">
                <img :src="ce.fileInfo.src"
                     @contextmenu.prevent="rightShow($event)"
                     ondragstart="return false;"
                     height="110px"
                     alt />

                <!-- 选用图片 -->
                <el-tooltip class="item"
                            effect="dark"
                            content="选用图片"
                            placement="top">
                  <div @click.stop="lovePicOut(ce,ci,i)"
                       v-if="ce.fileInfo.src !== 'error' && powersObj.selectPicture"
                       class="love">
                    <img v-if="loveList.indexOf(ce.id) === -1"
                         src="@/assets/piclist/love.png"
                         alt />
                    <img v-if="loveList.indexOf(ce.id) > -1"
                         src="@/assets/piclist/lovec.png"
                         alt />
                  </div>
                </el-tooltip>
              </div>
            </div>

            <div @click="actRight(i)"
                 v-if="e.pictureCount > 7"
                 class="right">
              <img src="@/assets/picbrowse/rightjt.png"
                   width="20px"
                   alt />
            </div>
          </div>
        </div>

        <div v-if="listPictureActivity.length === 0 "
             style="display: flex;align-items: center;justify-content:center;height:600px;">
          <img src="@/assets/piclist/nonr.png"
               alt />
        </div>
        <div v-if="listPictureActivity.length !== 0 "
             class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>

      </div>
    </div>

    <el-dialog :visible.sync="dialogVisibleInf"
               width="30%"
               :before-close="handleCloseInf">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>详细内容</div>
      </div>

      <div style="text-align:center;margin-bottom:20px;">{{actInf.title}}</div>

      <div>{{actInf.content}}</div>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisiblePutIn"
               width="26%"
               :before-close="handleClosePutIn">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>稿件入库</div>
      </div>
      <el-form :model="ruleForm"
               :rules="rules"
               ref="ruleForm"
               label-width="95px"
               class="demo-ruleForm"
               v-loading="dialogLoading">
        <el-form-item label="归属图库:"
                      prop="region">
          <el-cascader
                      style="width: 100%;"
                      v-model="ruleForm.region"
                      :options="libList"></el-cascader>
          <!-- <el-select v-model="ruleForm.region"
                     style="width:100%;"
                     placeholder="请选择图片库">
            <el-option v-for="item in libList"
                       :key="item.value + '-0'"
                       :label="item.label"
                       :value="item.value"
                       v-html="'<span style=color:#303030;>'+item.label+'</span>'"></el-option>
          </el-select> -->
        </el-form-item>
        <el-form-item label="图集名:"
                      prop="name">
          <el-input v-model="ruleForm.name"
                    placeholder="请输入图集名"></el-input>
        </el-form-item>

        <el-form-item label="备注:"
                      prop="desc">
          <el-input type="textarea"
                    :autosize="{ minRows: 8, maxRows: 12}"
                    v-model="ruleForm.desc"
                    placeholder="选填，备注不超过200个字"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button :disabled="dialogLoading"
                   @click="handleClosePutIn">取 消</el-button>
        <el-button :disabled="dialogLoading"
                   type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="subPutIn">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisibleMan"
               width="26%"
               class="clearMar"
               :before-close="handleCloseMan">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>用稿</div>
      </div>
      <div class="drawerbtn">
        <div>
          <div class="btnbj">
            <el-button v-if="powersObj.pictureDownload"
                       @click="downloadFlag = true"
                       class="btt">打包下载</el-button>
          </div>
          <!-- <br> -->
          <div class="btnbj">
            <el-button v-if="powersObj.pictureShare"
                       @click="shareFlag = true"
                       class="btt">分享</el-button>
          </div>
          <!-- <br> -->
          <div class="btnbj">
            <el-button v-if="powersObj.picturePush"
                       @click="pushFlag = true"
                       class="btt">推送</el-button>
          </div>
        </div>

        <transition name="el-fade-in-linear">
          <div v-if="downloadFlag"
               class="download"
               @click="downloadFlag = false">
            <div @click.stop
                 style="width:400px;margin:45px auto;">
              <el-input placeholder="请输入打包标题"
                        v-model="downloadTitle">
                <el-button @click.stop="downloadPic"
                           slot="append">打包下载</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="shareFlag"
               class="share"
               @click="shareFlag = false">
            <div @click.stop
                 style="width:400px;margin:110px auto;">
              <el-input placeholder="请输入分享标题"
                        v-model="shareTitle">
                <el-button @click.stop="sharePic"
                           slot="append">分享</el-button>
              </el-input>
            </div>
          </div>
        </transition>

        <transition name="el-fade-in-linear">
          <div v-if="pushFlag"
               class="push"
               @click="pushFlag = false">
            <div style="width:430px;margin:30px auto 0;">
              <p>推送至</p>
              <div class="pushbj">
                <div @click.stop="choosePush(i,e.template,e.name,e.id)"
                     :class="pushIndex === i?isSimple ?  'pushlist simpleactive' : 'pushlist active':'pushlist'"
                     v-for="(e,i) in pushList"
                     :key="i">
                  {{e.name}}
                  <img v-if="pushIndex === i"
                       src="@/assets/house/checkInside.png"
                       alt />
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </el-dialog>

    <el-dialog width="26%"
               :before-close="handleClosePic"
               :visible.sync="mydialogVisible">
      <div slot="title"
           class="header-title"
           :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>推送至图片邀约</div>
      </div>

      <el-form :model="myform"
               ref="myform"
               label-width="70px"
               :rules="rulestem">
        <!-- <el-form-item v-if="isSee" label="渠道名称：" prop="name">
            <el-input v-model="myform.name" placeholder="必填，2-10个字"></el-input>
        </el-form-item>-->
        <el-form-item label="标题："
                      prop="name">
          <el-select style="width:100%;"
                     v-model="myform.name"
                     @change="myformChange"
                     placeholder="请选择姓名">
            <el-option v-for="(e,i) in picInviteList"
                       :key="i"
                       :label="e.title"
                       :value="e.title"
                       v-html="'<span style=color:#303030;>'+e.title+'</span>'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div slot="label"
               class="labelclass">备注：</div>
          <el-input type="textarea"
                    :autosize="{ minRows: 7}"
                    v-model="myform.note"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClosePic">取 消</el-button>
        <el-button type="primary"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="submitPic('myform')">提 交</el-button>
      </div>
    </el-dialog>

    <!-- 图片点击弹窗 -->
    <el-dialog :visible.sync="dialogVisiblePicInfo"
               class="picSee"
               width="90%"
               top="12vh"
               :show-close="false">
      <!-- 关闭按钮 -->
      <div @click="dialogVisiblePicInfo = false"
           class="close">
        <img :style="{'margin-top':displayResolution < 1600 ? '-2px':'0px'}"
             src="@/assets/picbrowse/close.png"
             alt />
      </div>

      <div class="left">
        <div class="pic"
             v-loading="imgLoading"
             element-loading-text="正在加载图片中"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)">
          <div class="imgBj"
               ref="imgBj">
            <img ref="imgPic"
                 @contextmenu.prevent="rightShow($event)"
                 ondragstart="return false;"
                 height="98%"
                 @click="seeBigSmall"
                 v-lazy="choosePicMsg.src">
            <div @click="bigLeft"
                 class="leftjt">
              <div class="message"
                   v-show="showMessageLeft">这是第一张哟~</div>
            </div>
            <div @click="bigRight"
                 class="rightjt">
              <div class="message"
                   v-show="showMessageRight">这是最后一张哟~</div>
            </div>
            <i @click="picRotateRight"
               v-if="seeFull"
               class="el-icon-refresh-right"
               style="  position:absolute; bottom:20px; left:45%; font-size: 30px;"></i>
            <i @click="picRotateLeft"
               v-if="seeFull"
               class="el-icon-refresh-left"
               style="position:absolute; bottom:20px;font-size: 30px;"></i>
          </div>
          <!-- <img height="78%" :src="choosePicMsg.src"> -->

          <!-- <div class="picBtn">
            <i @click="picRotateRight"
               class="el-icon-refresh-right"></i>
            <i @click="picLarge"
               class="el-icon-zoom-in"></i>
            <i @click="picSmall"
               class="el-icon-zoom-out"></i>
            <i @click="picRotateLeft"
               class="el-icon-refresh-left"></i>
          </div> -->
        </div>

        <div class="picinf disflex">
          <!-- <p class="picinfleft">{{atlasInfo.name}} / 共<span>{{atlasInfo.pictureCount}}</span>张</p> -->
          <!-- <div class="picinfright disflex">
            <div v-if="powersObj.createAtlas" @click.stop="lovePic" class="disflex spare" :style="{background: !haslovechange ?'url('+ require('@/assets/picbrowse/spare.png') +') no-repeat':'url('+ require('@/assets/picbrowse/sparelove.png') +') no-repeat'}">
              <div class="icon"></div>
              
              <p>选用</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="setIndexPic" class="disflex book">
              <div class="icon"></div>
              
              <p>设为封面</p>
            </div>
            <div v-if="powersObj.createAtlas" @click="deletePic" class="disflex delete">
              <div class="icon"></div>
              
              <p>删除</p>
            </div>
          </div>-->
        </div>

        <div ref="piclist"
             class="piclist">
          <div v-if="picAllListFlag >= 13 || scroll < -1"
               @click="smallLeft"
               class="leftjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-left"></i>
          </div>

          <div ref="picalllist"
               style="display:flex;transition:1s;">
            <div @click="picListClick(e,i)"
                 v-for="(e,i) in picList"
                 :key="i">
              <!-- <img :src="e.src" :class="picAllListFlag === i || choosePicMsg.id === i ? 'picimg active':'picimg'" /> -->
              <div :style="{backgroundImage:'url(' + e.fileInfo.Wh160 + ')',cursor:'pointer'}"
                   @contextmenu.prevent="rightShow($event)"
                   ondragstart="return false;"
                   :class="picAllListFlag === i || choosePicMsg.myId === i ? 'picimg active':'picimg'"></div>
            </div>
          </div>

          <div v-if="picCha !== scroll && picList.length > 13"
               @click="smallRight"
               class="rightjt">
            <i style="font-size:30px;"
               class="el-icon-arrow-right"></i>
          </div>
        </div>
      </div>

      <div class="right">

        <div class="title">
          <p>图片信息</p>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">拍摄时间</div>： <span>{{picExif.CreateAtMy || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">上传时间</div>： <span>{{picInfo.createAt || '无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">相机品牌</div>： <span>{{picExif.Make || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片尺寸</div>： <span>{{ picInfo.picW !== '暂无' ? picInfo.picW + '*' + picInfo.picH + '像素' :'暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片大小</div>： <span>{{picInfo.fileSize}}MB</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片格式</div>： <span>{{picInfo.format}}</span>
        </div>
        <div v-if="picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>： <span>{{picExif.ExposureTime}}秒</span>
        </div>
        <div v-if="!picExif.ExposureTime"
             style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">曝光时间</div>： <span>暂无</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">ISO速度</div>： <span>{{picExif.ISOSpeedRatings || '暂无'}}</span>
        </div>
        <div style="display: flex;margin-bottom: 14px;padding-left:8px;">
          <div style="width:58px;">图片焦距</div>： <span>{{picExif.FocalLength || '暂无'}}</span>
        </div>

        <div style="margin-top:25px;"
             class="title"
             v-if="choosePicMsg.desc">
          <p>图片说明</p>
        </div>

        <p style="line-height:26px;padding-left:8px;">{{choosePicMsg.desc}}</p>

        <div class="msg disflex"
             v-if="false">
          <div class="picmsg">
            <p>{{choosePicMsg.shareCount}}</p>
            <div>浏览量</div>
            <img src="@/assets/picbrowse/see.png"
                 alt="">
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.pushCount}}</p>
            <div>推送量</div>
            <img src="@/assets/picbrowse/msgpush.png"
                 alt="">
          </div>
          <div class="picmsg">
            <p>{{choosePicMsg.downloadCount}}</p>
            <div>平台数</div>
            <img src="@/assets/picbrowse/platform.png"
                 alt="">
          </div>
        </div>

      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { listAccess } from "@/api/pictureNeed";
import { getPicturePackage } from "@/api/picturePackage";

import { setUserSetting, getUserSetting } from "@/api/config";

import { getPicture, addPicture, getPictures } from "@/api/picture";
import { getUser } from "@/api/user";
import { getFileInfoById } from "@/api/file";
import { listAllowPushChannel } from "@/api/pushChannel";
import { myPictureNeed, completePictureNeed, getPictureNeed, updatePictureNeed } from "@/api/pictureNeed";
import {
  listPictureActivityArticle,
  setCheck
} from "@/api/pictureActivityArticle";
import { picPrefix } from "@/constants/piccommon";
import { allowLib, powersObj } from "@/constants/powers";
import { listLib } from "@/api/lib";
import { addAtlas } from "@/api/atlas";
import { addPicturePackage } from "@/api/picturePackage";
import { getDate, formatConversion } from "@/plugins/getdate";
import { listPictureActivity } from "@/api/pictureActivity";
import { fullScreen, exitFullscreen, checkFull } from "@/plugins/fullScreen";
export default {
  components: {},
  computed: {
    ...mapGetters(["createUid"])
  },
  data () {
    return {
      seeFull: false,
      //权限
      allowLib,
      powersObj,

      total: 0,
      currentPage: 1,
      pageSize: 6,
      tableData: [],
      timeInt: "",
      activity: "",
      status: "",
      isCheck: "",
      isCheckList: [
        {
          value: -1,
          label: '不限'
        },
        {
          value: 0,
          label: "未审核"
        },
        {
          value: 1,
          label: "已审核"
        },
        {
          value: 2,
          label: "审核不通过"
        }
      ],
      statusList: [
        {
          value: -1,
          label: '不限'
        },
        {
          value: 0,
          label: "未使用"
        },
        {
          value: 1,
          label: "已入库"
        },
        {
          value: 2,
          label: "已用稿"
        }
      ],
      activityList: [],
      warehousingTime: "",
      listPictureActivity: [],

      libList: [],

      picPrefix,
      dialogVisibleInf: false,
      dialogVisiblePutIn: false,
      dialogVisibleMan: false,
      dialogVisiblePicInfo: false,
      actInf: "",

      putinPicIds: "",
      atlasId: "",
      libId: "",

      ruleForm: {
        name: "",
        region: "",
        desc: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入图集名", trigger: "blur" },
          { min: 1, max: 60, message: "长度在 1 到 60 个字符", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请选择图片库", trigger: "change" }
        ],
        desc: [
          {
            min: 0,
            max: 200,
            message: "长度不得超过200个字符",
            trigger: "blur"
          }
        ]
      },

      downloadFlag: false,
      shareFlag: false,
      pushFlag: false,
      downloadTitle: "",
      shareTitle: "",
      pushTitle: "",
      pushList: [],
      template: "",
      pushIndex: 0,
      pushChannelId: "",
      mydialogVisible: false,

      pictureArray: [],
      pictureString: [],
      picInviteList: [],
      myform: {
        name: "",
        note: "",
        createUid: this.createUid,
        id: ""
      },
      rulestem: {
        name: [{ required: true, message: "请选择模板", trigger: "change" }]
      },

      //图片浏览
      displayResolution: "",
      choosePicMsg: {},
      picList: [],
      imgLoading: false, //图片加载
      atlasInfo: {},
      picInfo: {},
      picExif: {},
      picCha: "",
      picAllListFlag: -1,


      scroll: 0,
      isRefresh: false,
      dialogLoading: false,

      picTimes: 1,
      picDeg: 0,
      passFlag: true,

      //鼠标右击
      rightMouseTop: 0,
      rightMouseLeft: 0,
      rightMouseFlag: false,


      //图片选用
      loveList: [],

      showMessageLeft: false,
      showMessageRight: false,
      isCreate: false,
      downloadPicText: '生成压缩包',

      pushList: []
    };
  },
  methods: {
    myformChange (val) {
      console.log(val);
      this.myform.name = val.title;
      this.myform.id = val.id;
    },
    async picNeedDown () {
      let { status, data, message, errors } = await getPictureNeed(this.$route.query.id);
      if (status) {
        if (data.downloadUrl !== '' && data.downloadUrl !== 'CREATEING' && data.downloadUrl !== 'ERROR') {
          let link = document.createElement('a') //创建a标签
          link.style.display = 'none'  //将a标签隐藏
          link.href = picPrefix + 'resource/' + data.downloadUrl  //给a标签添加下载链接
          link.setAttribute('target', '_blank')
          document.body.appendChild(link)
          link.click()  //执行a标签
        } else {
          this.$message('压缩包正在生成中……')
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //下载压缩包
    downloadPicNeed () {

      this.getPictureNeedAsync(this.$route.query.id)
      // this.completePictureNeedAsync({
      //   id:this.$route.query.id
      // })
    },

    //触发邀约打包
    async completePictureNeedAsync (val) {
      let { status, data, message, errors } = await completePictureNeed(val);
      if (status) {
        this.$message.success(message);
        this.downloadPicText = '正在生成压缩包'
        this.isCreate = false
        setTimeout(() => {
          this.downloadPicText = '生成压缩包'
          this.isCreate = true
        }, 8000);
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //修改邀约
    async updatePictureNeedAsync (val) {
      let { status, data, message, errors } = await updatePictureNeed(val);
      if (status) {
        this.completePictureNeedAsync({
          id: this.$route.query.id
        })
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //查询邀约
    async getPictureNeedAsync (val) {
      let { status, data, message, errors } = await getPictureNeed(val);
      if (status) {
        let picNeedInfor = data
        picNeedInfor.downloadUrl = 'CREATEING'
        this.updatePictureNeedAsync(picNeedInfor)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //查询邀约
    async getPictureNeedCreateAsync (val) {
      let { status, data, message, errors } = await getPictureNeed(val);
      if (status) {
        if (data.downloadUrl == 'CREATEING') {
          this.downloadPicText = '正在生成压缩包'
        } else if (data.downloadUrl == 'ERROR') {
          this.downloadPicText = '压缩包生成失败'
        } else {
          this.downloadPicText = '生成压缩包'
          this.isCreate = true
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //返回
    goback () {
      this.$router.go(-1)
    },

    //图片选用
    lovePicOut (e, j, i) {
      console.log(j, i);
      if (e.fileInfo.picThumbH160 == 'error') {
        this.$message.warning('图片生成失败，无法添加到选用图片!');
        return false
      }

      // this.listPictureActivity[i].pictureInfo[j]

      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)



      if (picLoveArray == null) {
        this.listPictureActivity[i].pictureInfo[j].isLove = false
      } else {
        for (let index = 0; index < picLoveArray.length; index++) {
          if (picLoveArray[index].id === this.listPictureActivity[i].pictureInfo[j].id) {
            this.listPictureActivity[i].pictureInfo[j].isLove = true

          }

        }
      }


      if (!this.listPictureActivity[i].pictureInfo[j].isLove) {

        // if (picLoveArray !== null) {
        //   if (picLoveArray.length > 34) {
        //     this.$message.warning('选用图片最多35张!');
        //     return false
        //   }
        // }

        this.loveList.push(this.listPictureActivity[i].pictureInfo[j].id)

        this.listPictureActivity[i].pictureInfo[j].isLove = true


        if (!picLoveArray) {
          let pL = []
          pL.push(this.listPictureActivity[i].pictureInfo[j])
          sessionStorage.setItem("picLove", JSON.stringify(pL));
          this.setUserSettingAsync(this.createUid, 'picLove', { value: this.listPictureActivity[i].pictureInfo[j].id })
          this.$message.success("添加成功")
        } else {
          picLoveArray.push(this.listPictureActivity[i].pictureInfo[j])
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("添加成功")
        }
      } else {
        this.loveList.splice(this.loveList.indexOf(this.listPictureActivity[i].pictureInfo[j].id), 1)


        this.listPictureActivity[i].pictureInfo[j].isLove = false


        if (picLoveArray.length === 1) {
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
          this.$message.success("移出成功")
        } else {
          let f
          for (let index = 0; index < picLoveArray.length; index++) {
            if (this.listPictureActivity[i].pictureInfo[j].id === picLoveArray[index].id) {
              f = i
            }
          }
          // console.log(picLoveArray)
          picLoveArray.splice(f, 1)
          sessionStorage.setItem("picLove", JSON.stringify(picLoveArray));
          let idsInfo = []
          for (let k = 0; k < picLoveArray.length; k++) {
            idsInfo.push({
              id: picLoveArray[k].id,
            })
          }
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
          this.$message.success("移出成功")
        }

      }
    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //图片右击
    rightShow (e) {
      this.rightMouseLeft = e.clientX
      this.rightMouseTop = e.clientY
      setTimeout(() => {
        this.rightMouseFlag = true
      }, 200);
      setTimeout(() => {
        this.rightMouseFlag = false
      }, 2000);
      // this.$message('版权所有')
    },


    seeBigSmall () {
      this.seeFull = !this.seeFull
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      if (this.seeFull) {
        fullScreen(this.$refs.imgBj)
        this.$refs.imgPic.style.cursor = 'zoom-out'
      } else {
        exitFullscreen()
        this.$refs.imgPic.style.cursor = 'zoom-in'
      }
    },
    comPic (val, tt) {
      // console.log(val,tt)
      let choosePicMsg = {
        createUid: this.createUid,
        packageType: val,
        pictureCount: this.pictureArray.length,
        pictureIds: this.pictureString,
        title: tt.name || tt.title || tt,
        pushConfig:
          JSON.stringify({
            pushChannelId: this.pushChannelId,
            pictureNeedId: tt.id,
            note: tt.note
          }) || ""
      };

      this.addPicturePackageAsync(choosePicMsg);
    },

    //图片放大
    picLarge () {
      this.picTimes += 1.5
      if (this.picTimes < 6) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 6
        this.$refs.imgPic.style.transform = 'scale(6) rotateZ(' + this.picDeg + 'deg)';
      }
    },
    //图片缩小
    picSmall () {
      this.picTimes -= 1.5
      if (this.picTimes > 1) {
        this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
      } else {
        this.picTimes = 1
        this.$refs.imgPic.style.transform = 'scale(1) rotateZ(' + this.picDeg + 'deg)';
      }
    },

    //图片旋转
    picRotateLeft () {
      this.picDeg -= 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //图片旋转
    picRotateRight () {
      this.picDeg += 90
      // if(this.picDeg >=360){
      //   this.picDeg = 0
      // }
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)'
    },
    //清除放大缩小效果
    clearLargeAndSmall () {
      this.$refs.imgPic.style.left = ''
      this.$refs.imgPic.style.top = ''
      this.picTimes = 1
      this.picDeg = 0
      this.$refs.imgPic.style.transform = 'scale(' + this.picTimes + ') rotateZ(' + this.picDeg + 'deg)';
    },

    //滚动加载图片
    scrollPic () {
      // let isBottom =
      //   document.documentElement.scrollTop + window.innerHeight ===
      //   document.body.offsetHeight;
      let isBottom =
        document.documentElement.scrollTop + window.innerHeight + 50 >=
        document.body.offsetHeight;
      // console.log(document.documentElement.scrollTop + window.innerHeight, document.body.offsetHeight);
      if (isBottom && this.passFlag) {
        this.passFlag = false
        if (this.listPictureActivity.length !== this.total) {
          let params = {
            page: this.currentPage,
            pageSize: this.pageSize,
            pictureNeedId: this.$route.query.id
          };
          this.listAccessAsync(params);
          this.currentPage++;
          console.log(this.currentPage);
        }
      }
    },

    //分页事件
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      let data = {
        page: this.currentPage - 1,
        pageSize: this.pageSize,
        pictureNeedId: this.$route.query.id
      };
      // console.log(data)
      this.listAccessAsync(data);


    },

    //刷新表格
    refresh () {
      this.activity = "";
      this.status = "";
      this.isCheck = "";
      this.loveList = []
      this.handleCurrentChange(1);
    },

    //判断选中的图片在什么位置
    beSurePic (i, num) {
      if (i > num) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        this.scroll = i * -80;
        // console.log(piclistwidth - picalllistwidth)
        // console.log(this.scroll)
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 70;
          this.picCha = this.scroll;
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + ")";
        this.scroll = 0;
      }
    },

    //获取图片信息
    getPicInfo (e) {
      this.picInfo.picH = e.fileInfo.picH || "暂无";
      this.picInfo.picW = e.fileInfo.picW || "暂无";
      this.picInfo.format =
        e.fileInfo.savepath.substring(e.fileInfo.savepath.length - 3) || "jpg";
      this.picInfo.createAt = formatConversion(
        e.fileInfo.createAt.toString()
      ).substring(0, 10);
      this.picInfo.fileSize =
        (e.fileInfo.fileSize / 1024 / 1024).toFixed(2) || "暂无";

      if (!e.exif) {
        this.picExif = {};
      } else {
        this.picExif = e.exif;
        if (e.exif.CreateAt) {
          this.picExif.CreateAtMy = formatConversion(
            this.picExif.CreateAt.toString()
          ).substring(0, 10);
        } else {
          this.picExif.CreateAtMy = null;
        }
      }
    },

    //图片浏览
    openDialog (i, e, picList) {
      this.dialogVisiblePicInfo = true;
      this.choosePicMsg = {};
      // console.log(e)
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.picW1080;
      this.choosePicMsg.picW1080 = e.fileInfo.picW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;
      this.picList = picList.pictureInfo;

      this.getPicInfo(e);

      this.$nextTick(() => {
        this.clearLargeAndSmall()
        this.beSurePic(i, 10);
      });
    },

    //图片浏览中大的箭头 左边
    bigLeft () {
      if (this.choosePicMsg.myId === 0) {
        if (!this.showMessageLeft) {
          this.showMessageLeft = true
          setTimeout(() => {
            this.showMessageLeft = false
          }, 1500);
        }
        return;
      }

      this.clearLargeAndSmall()

      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId - 1].fileInfo.picW1080;
      this.choosePicMsg.picW1080 = this.picList[this.choosePicMsg.myId - 1].fileInfo.picW1080;
      this.choosePicMsg.desc = this.picList[this.choosePicMsg.myId - 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId - 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId - 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId - 1;
      // console.log(this.choosePicMsg)
      this.picAllListFlag = this.choosePicMsg.myId;
      if (this.choosePicMsg.myId < 10) {
        this.scroll = 0;
        this.picCha = -1;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      } else {
        this.scroll = this.scroll + 3 * this.choosePicMsg.myId;
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览中大的箭头 右边
    bigRight () {
      if (this.choosePicMsg.myId === this.picList.length - 1) {
        if (!this.showMessageRight) {
          this.showMessageRight = true
          setTimeout(() => {
            this.showMessageRight = false
          }, 1500);
        }
        return;
      }
      this.clearLargeAndSmall()
      // this.picListClick(this.picList[this.choosePicMsg.id + 1],this.choosePicMsg.id + 1)
      this.choosePicMsg.src = this.picList[this.choosePicMsg.myId + 1].fileInfo.picW1080;
      this.choosePicMsg.picW1080 = this.picList[this.choosePicMsg.myId + 1].fileInfo.picW1080;
      this.choosePicMsg.desc =
        this.picList[this.choosePicMsg.myId + 1].desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.id = this.picList[this.choosePicMsg.myId + 1].id;

      this.getPicInfo(this.picList[this.choosePicMsg.myId + 1]);

      this.choosePicMsg.myId = this.choosePicMsg.myId + 1;
      this.picAllListFlag = this.choosePicMsg.myId;
      // console.log(this.choosePicMsg)
      if (this.choosePicMsg.myId > 10) {
        let picalllistwidth = this.$refs.picalllist.offsetWidth;
        let piclistwidth = this.$refs.piclist.offsetWidth;
        // console.log(this.scroll)
        // console.log(this.choosePicMsg.myId)
        if (this.scroll === 0) {
          this.scroll = this.choosePicMsg.myId * -70;
        } else {
          if (this.choosePicMsg.myId > 50) {
            this.scroll = this.scroll - 2 * this.choosePicMsg.myId;
          } else {
            this.scroll = this.scroll - 3 * this.choosePicMsg.myId;
          }
        }
        if (this.scroll < piclistwidth - picalllistwidth) {
          this.scroll = piclistwidth - picalllistwidth - 80;
          setTimeout(() => {
            this.picCha = this.scroll;
          }, 1000);
        }
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },
    //图片浏览小的箭头 右边
    smallRight () {
      let picalllistwidth = this.$refs.picalllist.offsetWidth;
      let piclistwidth = this.$refs.piclist.offsetWidth;
      this.scroll = this.scroll - 300;
      if (this.scroll < piclistwidth - picalllistwidth) {
        this.scroll = piclistwidth - picalllistwidth - 70;
        this.picCha = this.scroll;
        // console.log(this.scroll)
      }

      this.$refs.picalllist.style.transform =
        "translateX(" + this.scroll + "px)";
    },
    //图片浏览小的箭头 左边
    smallLeft () {
      this.scroll = this.scroll + 300;
      if (this.scroll > 0) {
        this.$refs.picalllist.style.transform = "translateX(" + 0 + "px)";
        this.scroll = 0;
      } else {
        this.$refs.picalllist.style.transform =
          "translateX(" + this.scroll + "px)";
      }
    },

    //图片浏览中图片点击
    picListClick (e, i) {
      this.clearLargeAndSmall()
      this.choosePicMsg.id = e.id;
      this.choosePicMsg.desc = e.desc;
      this.choosePicMsg.downloadCount = 0;
      this.choosePicMsg.pushCount = 0;
      this.choosePicMsg.shareCount = 0;
      this.choosePicMsg.src = e.fileInfo.picW1080;
      this.choosePicMsg.picW1080 = e.fileInfo.picW1080;
      this.choosePicMsg.myId = i;
      this.picAllListFlag = i;

      this.getPicInfo(e);
    },

    //搜索
    searchClick () {
      let data = {
        page: 0,
        pageSize: this.pageSize,
        pictureNeedId: this.$route.query.id
      };

      this.listAccessAsync(data);
    },

    //用稿操作
    useGao (e) {
      console.log(e);
      this.pictureArray = e.pictureIdsArray;
      this.pictureString = e.pictureIds;
      sessionStorage.setItem("actPic", JSON.stringify(e.pictureInfo));
      this.listAllowPushChannelAsync();
      this.dialogVisibleMan = true;
    },
    //图片包操作
    //推送
    pushPic (name) {
      if (this.template === "routersoft-qms") {
        this.handleClose();
        this.$router.push({
          path: "/shareAndPush/push/qms",
          query: {
            isSavePic: this.isSavePic,
            name: name,
            isAct: true,
            pushChannelId: this.pushChannelId
          }
        });
      } else if (
        this.template === "routersoft-rmt" ||
        this.template === "routersoft-mcp"
      ) {
        this.handleClose();
        this.$router.push({
          path: "/shareAndPush/push/mcp",
          query: {
            isSavePic: this.isSavePic,
            name: name,
            isAct: true,
            pushChannelId: this.pushChannelId
          }
        });
      } else if (
        this.template === "picture-need" ||
        this.template === "system-picture-need"
      ) {
        this.listPictureNeedAsync();
        this.mydialogVisible = true;
      }
    },
    handleClosePic () {
      this.mydialogVisible = false;
      // this.clearData()
    },
    //推送选择
    choosePush (i, t, name, id) {
      this.pushIndex = i;
      this.template = t;
      this.pushChannelId = id;
      this.pushPic(name);
    },
    //图片tuo
    submitPic (form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.comPic("push", this.myform);
          this.mydialogVisible = false;
          this.$router.push("/shareAndPush/myPush");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleClose () {
      this.downloadFlag = false;
      this.shareFlag = false;
      this.pushFlag = false;
      this.downloadTitle = "";
      this.shareTitle = "";
      this.pushTitle = "";
    },

    //分享
    sharePic () {
      if (this.shareFlag) {
        if (this.shareTitle == "") {
          this.$message.error("请输入标题！");
        } else {
          this.comPic("share", this.shareTitle);
          this.shareFlag = false;
          this.$router.push("/shareAndPush/myShare");
        }
      }
    },

    //打包下载
    downloadPic () {
      if (this.downloadFlag) {
        if (this.downloadTitle == "") {
          this.$message.error("请输入标题！");
        } else {
          this.comPic("download", this.downloadTitle);
          this.downloadFlag = false;
          this.$router.push("/shareAndPush/myDownload");
        }
      }
    },

    //入库操作
    putIn (e) {
      this.listLibAsync();
      this.putinPicIds = e;
      this.dialogVisiblePutIn = true;
    },

    //入库中
    subPutIn () {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.dialogLoading = true;
          let data = {
            name: this.ruleForm.name,
            desc: this.ruleForm.desc,
            libId: this.ruleForm.region,
            status: "0",
            sourceType: "0",
            createUid: this.createUid,
            indexpicId: "0"
          };
          this.addAtlasAsync(data);
        } else {
          return false;
        }
      });
    },

    //查看活动征稿的内容
    seeInf (e) {
      this.actInf = e;
      this.dialogVisibleInf = true;
    },

    checkClicksh (id) {
      this.$confirm("确认审核通过吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 1 });
        })
        .catch(e => { });
    },
    checkClickfs (id) {
      this.$confirm("确认撤回审核吗？", {
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(e => {
          this.setCheckAsync({ id, isCheck: 0 });
        })
        .catch(e => { });
    },

    handleCloseInf () {
      this.dialogVisibleInf = false;
    },
    handleClosePutIn () {
      this.dialogVisiblePutIn = false;
      this.$refs["ruleForm"].resetFields();
    },
    handleCloseMan () {
      this.dialogVisibleMan = false;
      this.handleClose();
    },

    //向右滚动
    actRight (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll > widthcha) {
        this.listPictureActivity[i].picScroll += -90;
      }

      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //向左滚动
    actLeft (i) {
      // this.scroll = 0
      let actimgwidth = this.$refs["actimg" + i][0].offsetWidth;
      let tablebgbodywidth = this.$refs["tablebgbody" + i][0].offsetWidth;
      let widthcha = tablebgbodywidth - actimgwidth;
      if (this.listPictureActivity[i].picScroll !== 0) {
        this.listPictureActivity[i].picScroll += 90;
      }
      this.$refs["actimg" + i][0].style.transform =
        "translateX(" + this.listPictureActivity[i].picScroll + "px)";
      // console.log(this.scroll, this.listPictureActivity[i].picScroll);
    },

    //设置审核结果
    async setCheckAsync (val) {
      let { status, data, message, pagination } = await setCheck(val);
      if (status) {
        this.$message.success("设置成功！");
        this.handleCurrentChange(this.currentPage);
      } else {
        this.$message.error("设置失败！");
      }
    },

    //获取征稿活动列表
    async listPictureActivityAsync (val) {
      let { status, data, message, pagination, errors } = await listPictureActivity({
        pageSize: 100
      });
      if (status) {
        this.activityList.push({
          value: 0,
          label: '不限'
        })
        for (let i = 0; i < data.length; i++) {
          this.activityList.push({
            value: data[i].id,
            label: data[i].title
          });
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取图片库列表
    async listLibAsync () {
      let { status, data, message, errors } = await listLib();
      if (status) {
        for (let i = 0; i < data.length; i++) {
          if (this.allowLib.indexOf(data[i].id.toString()) !== -1) {
            this.libList.push({
              value: data[i].id,
              label: data[i].name,
              children:[]
            });
          }
        }


        for (let i = 0;i < this.libList.length;i++) {
          let flag = 0
          for (let j = 0; j < this.allowLib.length; j++) {
            if(this.allowLib[j].toString().indexOf('-') !== -1){
              if(this.libList[i].value == this.allowLib[j].split('-')[0]){
                flag++
                this.libList[i].children.push({
                  value: this.allowLib[j].split('-')[1],
                  label: ''
                })
              }
            }
            
          }
          if(flag == 0){
            delete this.libList[i].children
          }
        }

        for (let i = 0; i < this.libList.length; i++) {
          if(this.libList[i].hasOwnProperty('children')){
            if(this.libList[i].children.length > 0){
              for (let z = 0; z < this.libList[i].children.length; z++) {
                for (let j = 0; j < data.length; j++) {
                  if(data[j].id == this.libList[i].children[z].value){
                    this.libList[i].children[z].label = data[j].name
                  }
                  
                }
                
              }
              
            }
          }
          
          
        }

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取图片邀约列表
    async listPictureNeedAsync () {
      let { status, data, message, pagination, errors } = await myPictureNeed();
      if (status) {
        this.picInviteList = data;

        if (data.length !== 0) {
          this.myform.name = this.picInviteList[0].title;
          this.myform.id = this.picInviteList[0].id;
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取允许的推送渠道
    async listAllowPushChannelAsync () {
      let { status, data, message, errors } = await listAllowPushChannel();
      if (status) {
        this.pushList = data;
        this.template = this.pushList[0].template;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包
    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("添加成功！");
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //创建图集
    async addAtlasAsync (val) {
      let libArr = val.libId
      if(libArr.length >= 2){
        val.parentLibId = parseInt(libArr[0])
        val.libId = parseInt(libArr[1])
      }else{
        val.parentLibId = 0
        val.libId = parseInt(libArr[0])
      }
      let { status, data, message, errors } = await addAtlas(val);
      if (status) {
        this.atlasId = data.id;
        this.libId = data.libId;

        let e = this.putinPicIds;

        for (let i = 0; i < e.pictureInfo.length; i++) {
          let picMsg = {
            atlasId: data.id,
            fileId: e.pictureInfo[i].id,
            libId: data.libId,
            desc: "",
            createUid: this.createUid,
            tags: ''
          };
          let addPic = await addPicture(picMsg);

          if (addPic.status) {
            if (i === e.pictureInfo.length - 1) {
              this.$message.success("创建图集成功！");
              this.dialogLoading = false;
              this.dialogVisiblePutIn = false;
              this.$refs["ruleForm"].resetFields();
            }
          }
        }
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.dialogLoading = false;
      }
    },

    //获取图片邀约中图片包列表
    async listAccessAsync (val) {
      this.isRefresh = true;
      let picLoveString = sessionStorage.getItem("picLove");
      let picLoveArray = JSON.parse(picLoveString)
      let {
        status,
        data,
        message,
        pagination, errors
      } = await listAccess(val);
      if (status) {
        // if (this.currentPage === 1) {
        //   this.listPictureActivity = data;
        // } else {
        //   for (let i = 0; i < data.length; i++) {
        //     this.listPictureActivity.push(data[i]);
        //   }
        // }
        let listPictureActivity = data

        this.total = pagination.total;
        for (let i = 0; i < listPictureActivity.length; i++) {
          listPictureActivity[i].picScroll = 0;
          listPictureActivity[i].pictureInfo = []
          listPictureActivity[i].createAtMy = formatConversion(
            listPictureActivity[i].createAt.toString()
          );
          let userInfo = await getUser(listPictureActivity[i].createUid)
          if (userInfo.status) {
            listPictureActivity[i].createName = userInfo.data.name
          } else {
            listPictureActivity[i].createName = '暂无'
          }

          let packInfo = await getPicturePackage(listPictureActivity[i].picturePackageId)
          let pictureIdsArray = packInfo.data.pictureIds.split(",")
          // console.log(packInfo)
          listPictureActivity[i].title = packInfo.data.title
          if (packInfo.data.pictureCount !== 0) {
            // console.log(packInfo.data.pictureIds)
            let pics = await getPictures({
              ids: packInfo.data.pictureIds
            });

            listPictureActivity[i].pictureInfo = pics.data;

            //判断是否为选用图片
            if (picLoveArray) {
              for (let index = 0; index < picLoveArray.length; index++) {
                for (let j = 0; j < listPictureActivity[i].pictureInfo.length; j++) {
                  if (picLoveArray[index].id === listPictureActivity[i].pictureInfo[j].id) {
                    listPictureActivity[i].pictureInfo[j].isLove = true
                    this.loveList.push(listPictureActivity[i].pictureInfo[j].id)
                  } else {
                    listPictureActivity[i].pictureInfo[j].isLove = false
                  }
                }
              }
            }

            for (
              let j = 0;
              j < listPictureActivity[i].pictureInfo.length;
              j++
            ) {



              if (listPictureActivity[i].pictureInfo[j].exif) {
                listPictureActivity[i].pictureInfo[j].exif = JSON.parse(listPictureActivity[i].pictureInfo[j].exif)
              }
              if (
                !listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160
              ) {
                listPictureActivity[i].pictureInfo[j].fileInfo.src = require('@/assets/house/onloadpicin.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicin.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpicin.png')
              } else {
                listPictureActivity[i].pictureInfo[j].fileInfo.src =
                  picPrefix +
                  listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbH160;
                listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 =
                  picPrefix +
                  listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbWh160;
                listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 =
                  picPrefix +
                  listPictureActivity[i].pictureInfo[j].fileInfo
                    .picThumbW1080;
              }

              //图片加载失败
              if (!listPictureActivity[i].pictureInfo[j].fileInfo || listPictureActivity[i].pictureInfo[j].picThumbH160 == 'error') {
                listPictureActivity[i].pictureInfo[j].fileInfo.src = require('@/assets/house/onloadpicerror.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpicerror.png')
              }

              let imgTest = new Image()
              imgTest.src = picPrefix + listPictureActivity[i].pictureInfo[j].fileInfo.picThumbH160;
              imgTest.onerror = () => {
                listPictureActivity[i].pictureInfo[j].fileInfo.src = require('@/assets/house/onloadpicerror.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.Wh160 = require('@/assets/house/onloadpicerror.png')
                listPictureActivity[i].pictureInfo[j].fileInfo.picW1080 = require('@/assets/house/onloadpicerror.png')
              }
            }

          }
        }


        this.listPictureActivity = listPictureActivity

        this.isRefresh = false;
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
        this.isRefresh = false;
      }
      this.passFlag = true
    }
  },
  created () {

    this.getPictureNeedCreateAsync(this.$route.query.id)

    window.onresize = () => {
      if (!checkFull()) {
        // 退出全屏后要执行的动作
        // console.log("退出全屏")
        this.seeFull = false;
      }
    }
    //获取屏幕的宽度来控制列表的间距
    this.displayResolution = document.documentElement.clientWidth;

    this.handleCurrentChange(this.currentPage);
    // let par = {
    //   page:this.currentPage - 1,
    //   pageSize:this.pageSize,
    //   pictureNeedId:this.$route.query.id
    // }
    // this.listAccessAsync(par);
    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 180000);
  },
  // mounted () { window.addEventListener('scroll', this.scrollPic); },
  destroyed () { //离开这个界面之后，删除，不然会有问题
    // window.removeEventListener('scroll', this.scrollPic)
  },
  beforeDestroy () {
    // 组件销毁前调用
    // clearTimeout(this.timeInt);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./picinviteseepic.scss";
@import "@/constants/elHeader.scss";
h4 {
  font-size: 18px;
}

/deep/ .el-select__caret:before {
  content: "\e78f";
  font-size: 16px;
  color: black;
}

.clearMar /deep/ .el-dialog__body {
  padding: 0;
}
</style>
